import type { ChartViewICProps } from "../types";
import { useConvertToChartDataIC } from "./useConvertToChartDataIC";
import { getOtherConfigXAxisIC, getOtherConfigYAxisIC } from "../utils";
import { useSetTotalCount } from "../../../hooks/useSetTotalCount";
import { getChartHeight } from "../../../utils/chartUtils";
import type { OtherChartConfig } from "@certa/common/types";
import { INDEX_ZERO } from "@certa/common/constants";

export const useChartViewIC = (props: ChartViewICProps) => {
  const { chartConfigIC, apiData, viewType, setTotalCount, isLoading } = props;

  const chartData = useConvertToChartDataIC({
    chartConfigIC,
    apiData
  });

  const xAxisDataLabels = chartConfigIC.groupBy
    .filter(groupBy => !groupBy.extraJSON.isForSecondaryXAxis)
    .map(x => x.extraJSON.label);

  const chartHeight = getChartHeight(viewType);
  const yAxisKey = chartConfigIC.operations[INDEX_ZERO]?.label ?? "";

  // create otherConfig for chart frp, chartConfigIC.otherConfigurations
  const otherConfig: OtherChartConfig = {
    ...chartConfigIC.otherConfigurations,
    xAxis: getOtherConfigXAxisIC(chartConfigIC),
    yAxis: getOtherConfigYAxisIC(chartConfigIC),
    shouldShowPercentagesInValueLabels:
      chartConfigIC.otherConfigurations.shouldShowPercentagesInValueLabels
  };

  useSetTotalCount({ chartData, isLoading, setTotalCount });
  return {
    chartData,
    hasData: !!chartData?.data?.length,
    xAxisDataLabels: xAxisDataLabels,
    chartHeight,
    otherConfig,
    yAxisKey
  };
};
